import React, { createContext, useContext, useRef } from 'react';
import { Toast } from 'primereact/toast';

type ToastContextValueT = {
  toast: Toast | null
}

const ToastContext = createContext<null | ToastContextValueT>(null);

export function ToastContextProvider({ children }) {
  const toast = useRef<Toast>(null);
  const contextValue = {
    get toast () {
      return toast.current
    }
  }
  return (
    <ToastContext.Provider value={contextValue}>
      <Toast position='bottom-center' ref={toast} />
      {children}
    </ToastContext.Provider>
  )
}

export function useToast () {
  const value = useContext(ToastContext);
  if (!value) throw new Error('ToastContextProvider has not been initialized');
  return value.toast;
}
